export default ({request}) => ({
    fabricStockInColorListApi(data = {}) {
        return request({
            url: '/digitalCenter/fabricStockInColor/list',
            method: 'post',
            data
        })
    },
    fabricStockInColorSaveApi(data = {}) {
        return request({
            url: '/digitalCenter/fabricStockInColor/save',
            method: 'post',
            data
        })
    },
    fabricStockInColorDelApi(data = {}) {
        return request({
            url: '/digitalCenter/fabricStockInColor/del',
            method: 'post',
            data
        })
    }
})
